/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {ContentBlockDataError, ContentDataEditableText, ContentDataMap, ContentDataPSGeneral, ContentDataPSIBIS, ContentDataStaticText,
  ContentDataStreetView, ContentDataDistrict, ContentDataEditableTable} from './content-block-data';
import {ContentBlockType} from './content-block-type';

export class ContentBlock {
    ORDER: number;
    DATA: ContentDataMap | ContentDataStreetView | ContentDataStaticText |
      ContentDataEditableText | ContentBlockDataError | ContentDataPSGeneral | ContentDataPSIBIS |
      ContentDataDistrict | ContentDataEditableTable;

    constructor(values: any = {}){
      Object.assign(this, values);

      let type = ContentBlockType[<string>values.DATA.TYPE];

      switch(type) {
      case ContentBlockType.MAP:
        this.DATA = new ContentDataMap(values.DATA);
        break;
      case ContentBlockType.STREET_VIEW:
        this.DATA = new ContentDataStreetView(values.DATA);
        break;
      case ContentBlockType.STATIC_TEXT:
        this.DATA = new ContentDataStaticText(values.DATA);
        break;
      case ContentBlockType.EDITABLE_TEXT:
        this.DATA = new ContentDataEditableText(values.DATA);
        break;
      case ContentBlockType.PREPARED_STATEMENT_GENERAL:
        this.DATA = new ContentDataPSGeneral(values.DATA);
        break;
      case ContentBlockType.PREPARED_STATEMENT_IBIS:
        this.DATA = new ContentDataPSIBIS(values.DATA);
        break;
      case ContentBlockType.ERROR:
        this.DATA = new ContentBlockDataError(values.DATA);
        break;
      case ContentBlockType.DISTRICT:
        this.DATA = new ContentDataDistrict(values.DATA);
        break;
      case ContentBlockType.EDITABLE_TABLE:
        this.DATA = new ContentDataEditableTable(values.DATA);
        break;
      }
    }

    static parseArray(json: any[]): ContentBlock[] {
      const arr = [];

      if (json)
        for (const j of json)
          if (j)
            arr.push(new ContentBlock(j));

      return arr;
    }
}

export interface IContentBlockData {
    TYPE: ContentBlockType;
}
